import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/35e01fee-9a30-4261-bd33-e9a61ecb65ca.jpg',
  text: 'Siempre perdía más tiempo buscando ideas que tejiendo. El Árbol de Decisiones cambió por completo mi rutina. Ahora en dos minutos ya sé exactamente qué proyecto empezar.',
  name: 'Claudia M.',
  place: 'Lima, Perú 🇵🇪'
}, {
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/1a904e70-9270-4d2e-8fc6-7826bf3eb4f9.jpg',
  text: 'Tenía una caja llena de ovillos que llevaba años guardando. El Tomo 3 me ayudó a aprovecharlos todos. Ya terminé cinco proyectos sin comprar una sola lana nueva.',
  name: 'Andrea R.',
  place: 'Santiago, Chile 🇨🇱'
}, {
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/f754a5bf-04b2-4eab-9b71-1d8015ce7a88.jpg',
  text: 'Pensé que era otro PDF bonito. Me sorprendió muchísimo. Todo tiene un orden lógico y realmente elimina la indecisión.',
  name: 'María L.',
  place: 'Buenos Aires, Argentina 🇦🇷'
}, {
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/c22bb2b6-5997-4f30-b956-c7099194aacb.jpg',
  text: 'Mi favorito fue el Plan de 30 Días. Volví a terminar proyectos que llevaban meses olvidados.',
  name: 'Patricia G.',
  place: 'Bogotá, Colombia 🇨🇴'
}, {
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/797964ca-1363-4019-b351-122ec781fb39.jpg',
  text: 'El bono de colores vale por sí solo el precio del sistema. Dejé de comprar lanas porque ahora sé cómo combinar las que ya tenía.',
  name: 'Silvia R.',
  place: 'Ciudad de México 🇲🇽'
}, {
  avatar: 'https://cdn.magicpatterns.com/patterns/generated-images/35e01fee-9a30-4261-bd33-e9a61ecb65ca.jpg',
  text: 'Lo mejor es que ya no me bloqueo. Tengo poco tiempo para tejer y ahora lo aprovecho al máximo.',
  name: 'Laura F.',
  place: 'Madrid, España 🇪🇸'
}];
function Stars() {
  return <div className="flex gap-0.5" data-id="element-219" data-mp="1sie84va0m5n7">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-220" data-mp="1oh2iwqv1zmfj" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-cream px-4 py-14" data-id="element-221" data-mp="1jhpui1oja7au">
      <div className="mx-auto max-w-3xl text-center" data-id="element-222" data-mp="1eiv6mlbplsjv">
        <h2 className="font-display text-2xl font-black leading-tight text-plum-deep sm:text-4xl" data-id="element-223" data-mp="1ekg007maf5g5">
          Lo que dicen nuestras tejedoras
        </h2>
        <div className="mt-3 flex items-center justify-center gap-2" data-id="element-224" data-mp="14sjz6osth188">
          <Stars data-id="element-225" data-mp="10rqc1xn77qge" />
          <span className="text-sm font-bold text-plum" data-id="element-226" data-mp="10s9tld8xsctw">4.9 / 5</span>
        </div>
        <p className="mt-2 text-sm text-plum/70" data-id="element-227" data-mp="vsneszdgmoiz">
          Más de <strong className="text-plum" data-id="element-228" data-mp="vs3z7pba8c84">5.000 tejedoras</strong> ya usan
          el Sistema ¿Qué Tejo Hoy?™
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-3xl gap-4 sm:grid-cols-2" data-id="element-229" data-mp="qvwsvvez4ypn">
        {testimonials.map((t, i) => <motion.figure key={t.name + i} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 2 * 0.08
      }} className="flex flex-col rounded-2xl bg-white p-5 shadow-sm ring-1 ring-mauve-soft/40" data-id="element-230" data-mp="37fqmxh8aq0wj" data-mpi={i}>
            <Stars data-id="element-231" data-mp="2js91e3fmjz20" />
            <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-plum/80" data-id="element-232" data-mp="2jol8n6i07goc">
              “{t.text}”
            </blockquote>
            <figcaption className="mt-4 flex items-center gap-3 border-t border-cream-2 pt-4" data-id="element-233" data-mp="2squgfolw0vy1">
              <img src={t.avatar} alt={t.name} className="h-12 w-12 flex-none rounded-full object-cover ring-2 ring-mauve-soft" data-id="element-234" data-mp="2xi2s6raowted" />
              <div data-id="element-235" data-mp="25104radb1dfd">
                <p className="text-sm font-bold text-plum" data-id="element-236" data-mp="250gpk1f1h351">{t.name}</p>
                <p className="text-xs text-plum/60" data-id="element-237" data-mp="1lwn6gx413toy">{t.place}</p>
              </div>
            </figcaption>
          </motion.figure>)}
      </div>
    </section>;
}